module.exports = __webpack_public_path__ + "68d96762691a936601114d143edd146d.jpg";